const getters = {
	userInfo: state => state.user.userInfo,//头部导航面包屑
  watermarkOpacity: state => state.user.watermarkOpacity, //水印透明度
	api: state => state.api.api,//后台接口
	windowSize:state => state.user.windowSize,//窗口大小
	orgInfo:state => state.user.orgInfo,//公司信息
	isChangePassword:state => state.user.isChangePassword,//密码规则
	desensitizationName:state => state.app.desensitizationName,//姓名脱敏
	desensitizationPhone:state => state.app.desensitizationPhone,//手机号脱敏
	imageCompressWidth:state => state.app.imageCompressWidth,//图片压缩宽度
	documentTypeList:state => state.user.documentTypeList,//证件类型
	contractStatusList:state => state.user.contractStatusList,//合同状态
	buttomList:state => state.user.buttomList,//权限按钮
  orgTree:state => state.user.orgTree,//组织树
  noticeTotalCount:state => state.app.noticeTotalCount,//告警消息总数量
  messageVisible:state => state.app.messageVisible,//消息通知开关
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js